<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
                <screenButton></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;" class="mater1">
      <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
               :items="items" :fields="fields" foot-clone>
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(archivesName)="data" style="'left':'80px';">
          <div v-if="data.item.archivesName">{{ data.item.archivesName }}</div>
          <div v-else>-</div>
        </template>
        <template v-slot:cell(materialData)="data" style="'left':'80px';">
          <div v-if="data.item.materialName">{{ data.item.materialName }}/{{ data.item.materialModel?data.item.materialModel:'-' }}/{{ data.item.materialUnit }}</div>
          <div v-else>-</div>
        </template>
        <template v-slot:cell(level)="data" style="'left':'80px';">
          <van-tag plain size="medium" :type="data.item.materialName?'success':'warning'">{{data.item.materialName?'物料':'类别'}}</van-tag>
        </template>
        <template v-slot:cell(adjustType)="data" style="'left':'80px';">
          <van-tag plain size="medium" :type="adjustTypeLabel(data.item).style">{{adjustTypeLabel(data.item).label}}</van-tag>
        </template>
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'materialData' ? '140px' : field.key === 'index' ?'30px':'100px',left: field.key === 'materialData' ? '120px' : '80px'}"
          />
        </template>
        <template v-slot:foot()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
        </template>
        <template v-slot:foot(index)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
        </template>
        <template v-slot:foot(num)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'num')}}</div>
        </template>
        <template v-slot:foot(adjustNum)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'adjustNum')}}</div>
        </template>
        <template v-slot:foot(numAfterAdjust)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'numAfterAdjust')}}</div>
        </template>
      </b-table>
      <!--       <div>{{items}}</div>-->
    </div>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import {BTable} from 'bootstrap-vue'


export default {
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'archivesName', stickyColumn: true, label: '分类名称'},
        {key: 'materialData', stickyColumn: true, label: '物料名称/规格/单位'},
        {key: 'level', label: '控量级别'},
        {key: 'adjustType', label: '调整类型'},
        {key: 'num', label: '预算数量'},
        {key: 'adjustNum', label: '调整数量'},
        {key: 'numAfterAdjust', label: '调整后预算数量'},
      ],
      items: [],
      dataList: [],
      businessId: '',
      searchForm: {
        deratedId: ''
      },
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        orders: []
      },
      layoutHeight: '0px',
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.items = query.data.budgetAdjustDetailList
      this.joint(["materialName", "materialModel", "materialUnit"])
    });
  },
  methods: {
    init() {
    },
    joint(data) {
      this.items.forEach(i => {
        i.materialData = {}
        data.forEach(key => {
          i.materialData[key] = i[key]
        })
      })
    },
    adjustTypeLabel(row) {
      if (row.adjustType == 1) {
        return {label: '新增', style: 'success'}
      } else if (row.adjustNum > 0) {
        return {label: '调增', style: 'primary'}
      } else {
        return {label: '调减', style: 'danger'}
      }
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>
<style>
.mater1 tr th:nth-child(2),.mater1 tr td:nth-child(2) {
  left: 30px !important;
}

.mater1 tr th:nth-child(3),.mater1 tr td:nth-child(3) {
  left: 110px !important;
}
</style>

